<template>
  <div class="subrangeListComponent">
    <b-card no-body>
      <b-card-header class="d-flex align-items-center justify-content-between">
        Actions
      </b-card-header>

      <b-card-body>
        <b-list-group>
          <b-list-group-item
            v-for="subrange of subrangeData"
            :key="subrange.index"
            :class="{ active: subrange.isActive }"
            class="subrangeListItem"
            :style="subrange.style"
            @click="$emit('activateSubrange', subrange.index)"
          >
            {{ subrange.label }} ({{ subrange.action }})
            <div class="comboCounts" v-if="subrange.combos > 0">
              <div>{{ subrange.comboPercent }}%</div>
              <div>{{ subrange.combos }}/{{ subrange.totalCombos }}</div>
            </div>
            <div class="color" :style="{ background: subrange.color }" />
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { fractionToPercent } from "../helpers/number";

export default {
  name: "SubrangeList",
  props: {
    subranges: { type: Array, required: true },
    colorScheme: { type: Array, required: true },
    activeSubrangeIndex: { type: Number, default: 0 },
    // {total: Number, bySubrangeIndex: {[index]: Number}}
    comboCounts: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    subrangeData() {
      return this.subranges.map((subrange, i) => {
        const isActive = i === this.activeSubrangeIndex;
        const color = this.colorScheme[i];
        const style = {};
        if (isActive) {
          style.backgroundColor = color;
          style.borderColor = color;
        }
        const totalCombos = this.comboCounts.total;
        const combos = this.comboCounts.bySubrangeIndex[i] || 0;
        const comboFraction = totalCombos === 0 ? 0 : combos / totalCombos;
        return {
          ...subrange,
          index: i,
          isActive,
          color,
          style,
          totalCombos,
          combos,
          comboPercent: fractionToPercent(comboFraction, 0),
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subrangeListComponent {
  width: 300px;
}
.subrangeListItem {
  position: relative;
  cursor: pointer;
  .color {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 10px;
  }
}
.comboCounts {
  position: absolute;
  top: 0;
  right: 2px;
  height: 100%;
  text-align: right;
  font-size: 10px;
}
</style>
